/**
 * 公告栏关闭功能
 * 点击关闭按钮时隐藏公告栏，并存储到 SessionStorage 中
 */
class AnnouncementBar {
  constructor() {
    this.closeButtons = document.querySelectorAll(
      ".announcement-bar__close-button"
    );
    this.initCloseButtons();
    this.checkSessionStorage();
  }

  /**
   * 初始化关闭按钮点击事件
   */
  initCloseButtons() {
    this.closeButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const announcementBar = this.findAnnouncementBar(button);
        if (announcementBar) {
          const barId = this.getAnnouncementBarId(announcementBar);
          this.hideAnnouncementBar(announcementBar, barId);
        }

        const announcementBarSection = document.querySelector(
          ".announcement-bar-section"
        );
        if (announcementBarSection) {
          announcementBarSection.style.display = "none";
          sessionStorage.setItem("announcement_section_hidden", "true");
        }
      });
    });
  }

  /**
   * 查找当前点击按钮对应的公告栏元素
   */
  findAnnouncementBar(button) {
    // 查找最近的公告栏容器
    const announcementItem =
      button.closest(".announcement-bar__announcement") ||
      button.closest(".announcement-bar") ||
      button.closest(".slideshow__slide");

    return announcementItem;
  }

  /**
   * 获取公告栏的唯一标识
   */
  getAnnouncementBarId(announcementBar) {
    // 使用数据属性作为ID，如果没有则创建一个基于内容的ID
    let barId = announcementBar.dataset.id;

    if (!barId) {
      // 如果没有ID，使用内容的哈希或索引作为ID
      const content = announcementBar.textContent.trim();
      barId = "announcement_" + this.hashString(content);
      announcementBar.dataset.id = barId;
    }

    return barId;
  }

  /**
   * 简单的字符串哈希函数
   */
  hashString(str) {
    let hash = 0;
    if (str.length === 0) return hash;

    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32bit integer
    }

    return Math.abs(hash).toString(16);
  }

  /**
   * 隐藏公告栏并保存状态到 SessionStorage
   */
  hideAnnouncementBar(announcementBar, barId) {
    announcementBar.style.display = "none";

    // 保存到 SessionStorage
    if (barId) {
      sessionStorage.setItem(barId, "hidden");
    }

    // 如果是滑块中的项目，可能需要调整滑块
    const slider = document.querySelector(".announcement-bar-slider");
    if (slider) {
      // 检查是否所有公告都被隐藏了
      const visibleSlides = slider.querySelectorAll(
        '.slideshow__slide:not([style*="display: none"])'
      );
      if (visibleSlides.length === 0) {
        // 所有公告都隐藏了，隐藏整个公告栏容器
        const container = document.querySelector(".announcement-bar");
        const announcementBarSection = document.querySelector(
          ".announcement-bar-section"
        );

        if (container && announcementBarSection) {
          container.style.display = "none";
          sessionStorage.setItem("announcement_container_hidden", "true");
        }
      }
    }
  }

  /**
   * 检查 SessionStorage 中的状态，如果公告栏之前被隐藏，则直接隐藏
   */
  checkSessionStorage() {
    // 检查整个公告栏区域是否被隐藏
    if (sessionStorage.getItem("announcement_section_hidden") === "true") {
      const announcementBarSection = document.querySelector(
        ".announcement-bar-section"
      );
      if (announcementBarSection) {
        announcementBarSection.style.display = "none";
      }
    }

    // 检查整个公告栏容器是否被隐藏
    if (sessionStorage.getItem("announcement_container_hidden") === "true") {
      const container = document.querySelector(".announcement-bar");
      if (container) {
        container.style.display = "none";
      }
    }

    // 检查各个公告项是否被隐藏
    const announcementItems = document.querySelectorAll(
      ".announcement-bar__announcement, .announcement-bar, .slideshow__slide"
    );

    announcementItems.forEach((item) => {
      // 获取或生成公告栏ID
      const barId = this.getAnnouncementBarId(item);

      // 检查该ID是否在SessionStorage中被标记为隐藏
      if (sessionStorage.getItem(barId) === "hidden") {
        item.style.display = "none";
      }
    });
  }
}

// 当DOM完全加载后初始化
document.addEventListener("DOMContentLoaded", () => {
  new AnnouncementBar();
});

// 在Shopify的主题编辑器中支持section重新加载
if (Shopify && Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.classList.contains("announcement-bar-section")) {
      new AnnouncementBar();
    }
  });
}
